







export default {
  name: 'SaveIcon',
  props: {
    color: {
      type: String,
      default: '#171717'
    }
  }
}
